<template>
  <v-widget
    :title="$t('Personal Information')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-form
        dense
      >
        <v-text-field
          v-model="customer.firstname"
          :error-count="customer.displayErrors('firstname').length"
          :error-messages="customer.displayErrors('firstname')"
          :label="$t('First Name')"
          outline
        />

        <v-text-field
          :error-count="customer.displayErrors('lastname').length"
          :error-messages="customer.displayErrors('lastname')"
          v-model="customer.lastname"
          :label="$t('Last Name')"
          outline
        />

        <v-text-field
          :error-count="customer.displayErrors('email').length"
          :error-messages="customer.displayErrors('email')"
          v-model="customer.email"
          :label="$t('Email')"
          outline
        />

        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :error-count="customer.displayErrors('dob').length"
              :error-messages="customer.displayErrors('dob')"
              v-model="customer.dob"
              :label="$t('Date of birth')"
              outline
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="customer.dob"
            @input="menu = false"
          />
        </v-menu>

        <telephone-field
          v-model="customer.telephone"
          outline
        />
      </v-form>
    </div>
  </v-widget>
</template>

<script>
import TelephoneField from '@/components/widgets/TelephoneField'
export default {
  name: 'CustomerProfile',
  components: { TelephoneField },
  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false
    }
  }
}
</script>
